'use strict';
angular.module('userManaShowUserRoleModule', []).
directive('userManaShowUserRole', ['$state', '$timeout', 'trsHttpService', 'modalDialog', function($state, $timeout, trsHttpService, modalDialog) {
    return {
        scope: {
            userId: "@",
            imgSrc: "@",
            imgTitle: "@"
        },
        restrict: 'E',
        templateUrl: './manageConfig/groupUserManageMent/user/directive/showUserRole/showUserRole_tpl.html',
        link: function(scope, element, attrs, controller) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.params = {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "getRoleGroupPath",
                    "RoleId": ""
                };
                /*scope.status = {
                    showModal: false
                };*/
                scope.data = {
                    role: [],
                    roleLength: "",
                    selectedRole: ""
                };
                //点击该组件以外的其他元素时隐藏下拉框
                $("*").click(function(event) {
                    if (!$(this).hasClass('showUserRole_' + scope.userId)) {
                        scope.data.selectedRole = "";
                        $('.showUserRole_modal_' + scope.userId).fadeOut();
                        // scope.status.showModal = false;
                    } else {
                        event.stopPropagation(); //阻止事件冒泡   
                    }
                });
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                //根据用户ID获取用户所属角色
                var params = {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "queryUserRoles",
                    "UserId": scope.userId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    scope.data.role = data;
                    scope.data.roleLength = data.length;
                    if (angular.isDefined(scope.data.role[0])) {
                        getGroupPathByRoleId(scope.data.role[0].ROLEID, 0);
                    }
                });
            }

            /**
             * [getGroupPathByRoleId description] 根据角色ID获取角色所属组织路径
             * @param  {[type]} roleid [description]
             * @param  {[type]} index  [description]
             * @return {[type]}        [description]
             */
            function getGroupPathByRoleId(roleid, index) {
                scope.params.RoleId = roleid;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), scope.params, 'get').then(function(data) {
                    if (data.length > 0) {
                        scope.data.role[index].ROLEGROUPPATH = data[0].ROLEGROUPPATH;
                        scope.data.role[index].GROUPID = data[0].GROUPID;
                        index++;
                        if (index < scope.data.role.length) {
                            getGroupPathByRoleId(scope.data.role[index].ROLEID, index);
                        }
                    } else {
                        index++;
                        if (index < scope.data.role.length) {
                            getGroupPathByRoleId(scope.data.role[index].ROLEID, index);
                        }
                    }
                }, function() {
                    index++;
                    if (index < scope.data.role.length) {
                        getGroupPathByRoleId(scope.data.role[index].ROLEID, index);
                    }
                });
            }

            /**
             * [showModal description] 显示角色列表
             * @return {[type]} [description]
             */
            scope.showModal = function() {
                $('.showUserRole_modal').fadeOut();
                scope.data.selectedRole = "";
                $('.showUserRole_modal_' + scope.userId).fadeIn();
                /*if (scope.status.showModal === false) {
                    $('.showUserRole_modal_' + scope.userId).fadeIn();
                    scope.status.showModal = true;
                } else {
                    $('.showUserRole_modal_' + scope.userId).fadeOut();
                    scope.status.showModal = false;
                }*/
            };

            /**
             * [selectRole description] 选择角色
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            scope.selectRole = function(item) {
                if (scope.data.selectedRole == item) {
                    scope.data.selectedRole = "";
                } else {
                    scope.data.selectedRole = item;
                };
            };

            /**
             * [isConfirm description] 确定
             * @return {Boolean} [description]
             */
            scope.isConfirm = function() {
                if (scope.data.selectedRole.length == 0) {
                    modalDialog.alertType("", "请先选择角色", "info", false);
                    return;
                };
                var groupid = scope.data.selectedRole.GROUPID;
                var roleid = scope.data.selectedRole.ROLEID;
                $state.go("manageconfig.rolemanage.editorcreaterole", { type: 'edit', groupid: groupid, roleid: roleid }, { reload: true });
                /*scope.selectedRole = scope.data.selectedRole;
                $timeout(function() {
                    scope.callback();
                });
                scope.data.selectedRole = "";
                $('.showUserRole_modal_'+scope.userId).fadeOut();
                scope.status.showModal = false;*/
            };

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            scope.cancel = function() {
                scope.data.selectedRole = "";
                $('.showUserRole_modal_' + scope.userId).fadeOut();
                // scope.status.showModal = false;
            };
            /**
             * [handleRolePath description] 处理角色路径文字格式
             * @param {object} [item] [description] 用户信息
             * @return {[type]} [description]
             */
            scope.handleRolePath = function(item) {
                if (angular.isUndefined(item.ROLEGROUPPATH)) return;
                var rolePathArray = item.ROLEGROUPPATH.split(">");
                rolePathArray = rolePathArray.map(function(data) {
                    return "<span class='role_path'>" + data + "</span>";
                });
                var rolePath = rolePathArray.join("<span class='separator'>›</span>");
                rolePath += ("<span class='separator'>›</span><span>" + item.ROLENAME + "</span>");
                return rolePath;
            };
        }
    };
}]);